export default __webpack_public_path__ + "static/media/B_Bermuda.b44e55bf.svg";